import { getSignzyDetails } from "../../../services/httpCalls";

export const getPanDetails = async (
    {
        pan,
        form,
        notify,
        setShowLoader,
        setIsGstNotThere
    }
) => {
    setShowLoader(true)
    await getSignzyDetails(pan)
      .then((res) => {
        if (res?.gstDetailsResult) {
          form.setFieldValue("gstNumber", res?.gstDetailsResult?.gstin)
          setIsGstNotThere(false)
          if(res?.gstDetailsResult?.gstnDetailed?.length){
            form.setFieldsValue({
              "registeredAddress_addressLineOne": res?.gstDetailsResult?.gstnDetailed[0]?.principalPlaceBuildingNoFromGST +" "+ res?.gstDetailsResult?.gstnDetailed[0]?.principalPlaceBuildingNameFromGST,
              "registeredAddress_addressLineTwo": res?.gstDetailsResult?.gstnDetailed[0]?.principalPlaceStreet,
              "registeredAddress_city" : res?.gstDetailsResult?.gstnDetailed[0]?.principalPlaceLocality,
              "registeredAddress_state" : res?.gstDetailsResult?.gstnDetailed[0]?.principalPlaceState,
              "registeredAddress_pinCode" : res?.gstDetailsResult?.gstnDetailed[0]?.principalPlacePincode,
              "doingBusinessAs": res?.gstDetailsResult?.gstnDetailed[0]?.tradeNameOfBusiness
            })
          }else{
            form.resetFields(["registeredAddress_addressLineOne", "registeredAddress_addressLineTwo", "registeredAddress_city", "registeredAddress_state", "registeredAddress_pinCode", "doingBusinessAs"])
          }
        }else{
          form.resetFields(["gstNumber"])
        }
        if(res?.result?.name){
          form.setFieldValue("legalName", res?.result?.name)
        }else{
          form.resetFields(["legalName"])
        }
      })
      .catch((_err) => {
        notify.info("Data retrieval issue. Please fill in details manually.");
        form.resetFields(["gstNumber", "legalName", "registeredAddress_addressLineOne", "registeredAddress_addressLineTwo", "registeredAddress_city", "registeredAddress_state", "registeredAddress_pinCode", "doingBusinessAs"])
      })
      .finally(() => {
        setShowLoader(false);
      });
}